import { showErrorAlert } from '../view/showErrorAlert.js';
import { showFormAlert } from '../view/showFormAlert.js';
import { getCertDetail } from './BMCERT/getCertDetail.js';
import { isCertDataValid } from './BMCERT/isCertDataValid.js';

/* EXAMPLE stepData
  {
    "numserie": "44151188",
    "usuario": "CN=EMPLEADO_TEST100, O=DEMO - UNIVERSIDAD ROBOTICA ESPANOLA, serialNumber=TESTTEST100, emailAddress=jsalinas@edicomgroup.com, C=MX",
    "validezhasta": "08/02/2024",
    "emisor": "CN=EMPLEADO_TEST100, O=DEMO - UNIVERSIDAD ROBOTICA ESPANOLA, serialNumber=TESTTEST100, emailAddress=jsalinas@edicomgroup.com, C=MX"
  }
*/
export default {
  events: {
    visible: (eWizard, stepData, params, enrollform) => {
      // Típica incidencia en algunos dominios
      if (!Object.keys(stepData).length) {
        showErrorAlert('global.error', 'enrollment.bmcert.certificate.empty', 10000);
      }

      // setExtraInformation
      const eAlert = eWizard.querySelector('#alertCert');
      if (eAlert) {
        const certExtraInformation = edicom.locale.translate(params.extraInformation || 'enrollment.bmcert.intro.2');
        const certExtraInformationReneweed = edicom.locale.translate(params.extraInformationRenewed || 'enrollment.bmcert.intro.3');
        eAlert.lastElementChild.insertAdjacentHTML('beforeend', `${certExtraInformation}<br/>${certExtraInformationReneweed}`);
      }

      // Control para bloquear form
      if (isCertDataValid(stepData)) {
        eWizard.querySelector('#aceptcert')?.removeAttribute('disabled');
        eWizard.querySelector('#detailCert')?.render(getCertDetail(stepData, enrollform));
      } else {
        // No podemos continuar
        eWizard.eBtnNext?.setAttribute('disabled', '');
        eWizard.eBtnFinish?.setAttribute('disabled', '');
      }
    },
    step: (eWizard, stepData, resolve, reject) => {
      const checkMandatory = eWizard.querySelector('#aceptcert')?.value;
      if (checkMandatory) {
        stepData.aceptcert = 1;
        resolve(stepData); // OK
      } else {
        showFormAlert();
        reject(); // KO
      }
    },
  },
  template: `
  <template label="${edicom.locale.translate('enrollment.bmcert.title')}">
    <ewc-layout>
      <div slot="main">
        <ewc-alert id="alertCert" type="flat" label="${edicom.locale.translate('enrollment.bmcert.title')}">
          <div style="white-space:normal;">${edicom.locale.translate('enrollment.bmcert.intro.1')}<br/></div>
        </ewc-alert>
        <ewc-detail-list id="detailCert" filter=""></ewc-detail-list>
        <ewc-checkbox id="aceptcert" required disabled label="${edicom.locale.translate('enrollment.bmcert.label.certagree')}"></ewc-checkbox>
      </div>
    </ewc-layout>
  </template>`,
};
